"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function capitalize(value) {
  const phrase = String(value !== null && value !== void 0 ? value : '');
  return phrase.charAt(0).toUpperCase() + phrase.slice(1);
}
var _default = exports.default = capitalize;